//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import AxiosClient from './axiosClient';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class DocumentSectionCommentClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createComment(documentSectionId: string, model: CreateCommentModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/comment/{documentSectionId}";
        if (documentSectionId === undefined || documentSectionId === null)
            throw new Error("The parameter 'documentSectionId' must be defined.");
        url_ = url_.replace("{documentSectionId}", encodeURIComponent("" + documentSectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateComment(_response));
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    delete(documentSectionCommentId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/comment/{documentSectionCommentId}";
        if (documentSectionCommentId === undefined || documentSectionCommentId === null)
            throw new Error("The parameter 'documentSectionCommentId' must be defined.");
        url_ = url_.replace("{documentSectionCommentId}", encodeURIComponent("" + documentSectionCommentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    resolve(documentSectionCommentId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/comment/resolve/{documentSectionCommentId}";
        if (documentSectionCommentId === undefined || documentSectionCommentId === null)
            throw new Error("The parameter 'documentSectionCommentId' must be defined.");
        url_ = url_.replace("{documentSectionCommentId}", encodeURIComponent("" + documentSectionCommentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResolve(_response));
        });
    }

    protected processResolve(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentSectionReviewClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createReview(documentSectionId: string, model: CreateReviewModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/review/{documentSectionId}";
        if (documentSectionId === undefined || documentSectionId === null)
            throw new Error("The parameter 'documentSectionId' must be defined.");
        url_ = url_.replace("{documentSectionId}", encodeURIComponent("" + documentSectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateReview(_response));
        });
    }

    protected processCreateReview(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    reject(documentSectionReviewId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/review/reject/{documentSectionReviewId}";
        if (documentSectionReviewId === undefined || documentSectionReviewId === null)
            throw new Error("The parameter 'documentSectionReviewId' must be defined.");
        url_ = url_.replace("{documentSectionReviewId}", encodeURIComponent("" + documentSectionReviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processReject(_response));
        });
    }

    protected processReject(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    acceptWithChanges(documentSectionReviewId: string, model: AcceptReviewWithChangesModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/review/acceptWithChanges/{documentSectionReviewId}";
        if (documentSectionReviewId === undefined || documentSectionReviewId === null)
            throw new Error("The parameter 'documentSectionReviewId' must be defined.");
        url_ = url_.replace("{documentSectionReviewId}", encodeURIComponent("" + documentSectionReviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAcceptWithChanges(_response));
        });
    }

    protected processAcceptWithChanges(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UserProfileClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    searchUsers(searchTerm: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<SearchResultModel[]> {
        let url_ = this.baseUrl + "/api/profiles/search?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSearchUsers(_response));
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<SearchResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchResultModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SearchResultModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SearchResultModel[]>(null as any);
    }

    getUserProfile(userId: string , cancelToken?: CancelToken | undefined): Promise<ProfileModel> {
        let url_ = this.baseUrl + "/api/profiles/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserProfile(_response));
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<ProfileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileModel.fromJS(resultData200);
            return Promise.resolve<ProfileModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileModel>(null as any);
    }
}

export class TemplateVariablesClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createVariable(templateVersionId: string, model: CreateTemplateVariableModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/template-variables/template-versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateVariable(_response));
        });
    }

    protected processCreateVariable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getVariables(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateVariableModel[]> {
        let url_ = this.baseUrl + "/api/template-variables/template-versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVariables(_response));
        });
    }

    protected processGetVariables(response: AxiosResponse): Promise<TemplateVariableModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateVariableModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateVariableModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateVariableModel[]>(null as any);
    }

    updateVariable(templateVariableId: string, model: UpdateTemplateVariableValueModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/template-variables/{templateVariableId}";
        if (templateVariableId === undefined || templateVariableId === null)
            throw new Error("The parameter 'templateVariableId' must be defined.");
        url_ = url_.replace("{templateVariableId}", encodeURIComponent("" + templateVariableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateVariable(_response));
        });
    }

    protected processUpdateVariable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TemplateAuditClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getTimelineForTemplateVersion(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionAuditEntry[]> {
        let url_ = this.baseUrl + "/api/template_audits/documents/versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimelineForTemplateVersion(_response));
        });
    }

    protected processGetTimelineForTemplateVersion(response: AxiosResponse): Promise<TemplateSectionAuditEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSectionAuditEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSectionAuditEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionAuditEntry[]>(null as any);
    }

    getTimelineForSection(templateSectionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionAuditEntry[]> {
        let url_ = this.baseUrl + "/api/template_audits/sections/{templateSectionId}";
        if (templateSectionId === undefined || templateSectionId === null)
            throw new Error("The parameter 'templateSectionId' must be defined.");
        url_ = url_.replace("{templateSectionId}", encodeURIComponent("" + templateSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimelineForSection(_response));
        });
    }

    protected processGetTimelineForSection(response: AxiosResponse): Promise<TemplateSectionAuditEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSectionAuditEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSectionAuditEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionAuditEntry[]>(null as any);
    }
}

export class TemplatesClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getTemplates(  cancelToken?: CancelToken | undefined): Promise<TemplateSummary[]> {
        let url_ = this.baseUrl + "/api/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplates(_response));
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<TemplateSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSummary[]>(null as any);
    }

    getArchivedTemplates(  cancelToken?: CancelToken | undefined): Promise<TemplateSummary[]> {
        let url_ = this.baseUrl + "/api/templates/archived";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetArchivedTemplates(_response));
        });
    }

    protected processGetArchivedTemplates(response: AxiosResponse): Promise<TemplateSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSummary[]>(null as any);
    }

    createTemplate(model: CreateTemplateModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/templates/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTemplate(_response));
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getTemplateSections(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateVersionEditModel> {
        let url_ = this.baseUrl + "/api/templates/versions/{templateVersionId}/sections";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplateSections(_response));
        });
    }

    protected processGetTemplateSections(response: AxiosResponse): Promise<TemplateVersionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateVersionEditModel.fromJS(resultData200);
            return Promise.resolve<TemplateVersionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateVersionEditModel>(null as any);
    }

    getSectionVersionDetails(templateSectionVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionVersionDetails> {
        let url_ = this.baseUrl + "/api/templates/sections/versions/{templateSectionVersionId}";
        if (templateSectionVersionId === undefined || templateSectionVersionId === null)
            throw new Error("The parameter 'templateSectionVersionId' must be defined.");
        url_ = url_.replace("{templateSectionVersionId}", encodeURIComponent("" + templateSectionVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSectionVersionDetails(_response));
        });
    }

    protected processGetSectionVersionDetails(response: AxiosResponse): Promise<TemplateSectionVersionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateSectionVersionDetails.fromJS(resultData200);
            return Promise.resolve<TemplateSectionVersionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionVersionDetails>(null as any);
    }

    getTemplatesForTags(tagIds: string[] | null | undefined , cancelToken?: CancelToken | undefined): Promise<TemplateSummary[]> {
        let url_ = this.baseUrl + "/api/templates/tags?";
        if (tagIds !== undefined && tagIds !== null)
            tagIds && tagIds.forEach(item => { url_ += "tagIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplatesForTags(_response));
        });
    }

    protected processGetTemplatesForTags(response: AxiosResponse): Promise<TemplateSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSummary[]>(null as any);
    }

    archiveTemplate(templateId: string , cancelToken?: CancelToken | undefined): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/templates/archive/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveTemplate(_response));
        });
    }

    protected processArchiveTemplate(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }

    unarchiveTemplate(templateId: string , cancelToken?: CancelToken | undefined): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/templates/unarchive/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnarchiveTemplate(_response));
        });
    }

    protected processUnarchiveTemplate(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }
}

export class TemplateEditorClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getTemplateHeading(templateId: string , cancelToken?: CancelToken | undefined): Promise<TemplateEditModel> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/headings";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplateHeading(_response));
        });
    }

    protected processGetTemplateHeading(response: AxiosResponse): Promise<TemplateEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateEditModel.fromJS(resultData200);
            return Promise.resolve<TemplateEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateEditModel>(null as any);
    }

    getTemplateVersionSectionHeadings(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionHeading[]> {
        let url_ = this.baseUrl + "/template-editor/versions/{templateVersionId}/headings";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTemplateVersionSectionHeadings(_response));
        });
    }

    protected processGetTemplateVersionSectionHeadings(response: AxiosResponse): Promise<TemplateSectionHeading[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSectionHeading.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSectionHeading[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionHeading[]>(null as any);
    }

    addSection(templateVersionId: string, sectionTitle: string | null | undefined, order: number | undefined, parentSectionId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/template-editor/{templateVersionId}/section/create";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sectionTitle !== null && sectionTitle !== undefined)
            content_.append("sectionTitle", sectionTitle.toString());
        if (order === null || order === undefined)
            throw new Error("The parameter 'order' cannot be null.");
        else
            content_.append("order", order.toString());
        if (parentSectionId !== null && parentSectionId !== undefined)
            content_.append("parentSectionId", parentSectionId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddSection(_response));
        });
    }

    protected processAddSection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getContent(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateVersionEditModel> {
        let url_ = this.baseUrl + "/template-editor/versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetContent(_response));
        });
    }

    protected processGetContent(response: AxiosResponse): Promise<TemplateVersionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateVersionEditModel.fromJS(resultData200);
            return Promise.resolve<TemplateVersionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateVersionEditModel>(null as any);
    }

    updateSection(id: string | undefined, model: UpdateTemplateSectionRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/section/update?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSection(_response));
        });
    }

    protected processUpdateSection(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteSection(templateSectionId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/sections/{templateSectionId}";
        if (templateSectionId === undefined || templateSectionId === null)
            throw new Error("The parameter 'templateSectionId' must be defined.");
        url_ = url_.replace("{templateSectionId}", encodeURIComponent("" + templateSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSection(_response));
        });
    }

    protected processDeleteSection(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSectionDetails(templateSectionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionEditModel> {
        let url_ = this.baseUrl + "/template-editor/sections/{templateSectionId}";
        if (templateSectionId === undefined || templateSectionId === null)
            throw new Error("The parameter 'templateSectionId' must be defined.");
        url_ = url_.replace("{templateSectionId}", encodeURIComponent("" + templateSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSectionDetails(_response));
        });
    }

    protected processGetSectionDetails(response: AxiosResponse): Promise<TemplateSectionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TemplateSectionEditModel.fromJS(resultData200);
            return Promise.resolve<TemplateSectionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionEditModel>(null as any);
    }

    renameTemplate(templateId: string, model: RenameTemplateModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/rename";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRenameTemplate(_response));
        });
    }

    protected processRenameTemplate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateTemplateSummary(templateId: string, model: UpdateTemplateSummaryModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/summary";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTemplateSummary(_response));
        });
    }

    protected processUpdateTemplateSummary(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    renameTemplateVersion(templateVersionId: string, model: RenameTemplateModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/versions/{templateVersionId}/rename";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRenameTemplateVersion(_response));
        });
    }

    protected processRenameTemplateVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateTags(templateId: string, model: UpdateTemplateTagsRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/tags";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateTags(_response));
        });
    }

    protected processUpdateTags(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getOrderOfSections(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateSectionOrderModel[]> {
        let url_ = this.baseUrl + "/template-editor/versions/{templateVersionId}/sections/order";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrderOfSections(_response));
        });
    }

    protected processGetOrderOfSections(response: AxiosResponse): Promise<TemplateSectionOrderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateSectionOrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateSectionOrderModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateSectionOrderModel[]>(null as any);
    }

    updateSectionOrder(sectionId: string, model: UpdateTemplateSectionOrderRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/versions/sections/{sectionId}/order";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSectionOrder(_response));
        });
    }

    protected processUpdateSectionOrder(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    publish(templateId: string, model: PublishTemplateVersionRequest , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/publish";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processPublish(_response));
        });
    }

    protected processPublish(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    addVersion(templateId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/template-editor/{templateId}/version/create";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddVersion(_response));
        });
    }

    protected processAddVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TemplateAbbreviationsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createAbbreviation(templateVersionId: string, model: CreateTemplateAbbreviationModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/template-abbreviations/template-versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAbbreviation(_response));
        });
    }

    protected processCreateAbbreviation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAbbreviations(templateVersionId: string , cancelToken?: CancelToken | undefined): Promise<TemplateAbbreviationModel[]> {
        let url_ = this.baseUrl + "/api/template-abbreviations/template-versions/{templateVersionId}";
        if (templateVersionId === undefined || templateVersionId === null)
            throw new Error("The parameter 'templateVersionId' must be defined.");
        url_ = url_.replace("{templateVersionId}", encodeURIComponent("" + templateVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAbbreviations(_response));
        });
    }

    protected processGetAbbreviations(response: AxiosResponse): Promise<TemplateAbbreviationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateAbbreviationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TemplateAbbreviationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TemplateAbbreviationModel[]>(null as any);
    }

    updateAbbreviation(templateAbbreviationId: string, model: UpdateTemplateAbbreviationValueModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/template-abbreviations/{templateAbbreviationId}";
        if (templateAbbreviationId === undefined || templateAbbreviationId === null)
            throw new Error("The parameter 'templateAbbreviationId' must be defined.");
        url_ = url_.replace("{templateAbbreviationId}", encodeURIComponent("" + templateAbbreviationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAbbreviation(_response));
        });
    }

    protected processUpdateAbbreviation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TagsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getCategories(  cancelToken?: CancelToken | undefined): Promise<TagCategoryModel[]> {
        let url_ = this.baseUrl + "/api/tags/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCategories(_response));
        });
    }

    protected processGetCategories(response: AxiosResponse): Promise<TagCategoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagCategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagCategoryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagCategoryModel[]>(null as any);
    }

    getTagsForCategory(tagCategoryId: string , cancelToken?: CancelToken | undefined): Promise<TagCategoryModel[]> {
        let url_ = this.baseUrl + "/api/tags/categories/{tagCategoryId}";
        if (tagCategoryId === undefined || tagCategoryId === null)
            throw new Error("The parameter 'tagCategoryId' must be defined.");
        url_ = url_.replace("{tagCategoryId}", encodeURIComponent("" + tagCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTagsForCategory(_response));
        });
    }

    protected processGetTagsForCategory(response: AxiosResponse): Promise<TagCategoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagCategoryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagCategoryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagCategoryModel[]>(null as any);
    }
}

export class StripeClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    handleWebhook(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHandleWebhook(_response));
        });
    }

    protected processHandleWebhook(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ProjectsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    create(model: CreateProjectModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    userProjects(  cancelToken?: CancelToken | undefined): Promise<ProjectSummary[]> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUserProjects(_response));
        });
    }

    protected processUserProjects(response: AxiosResponse): Promise<ProjectSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectSummary[]>(null as any);
    }

    checkActiveProjectAvailable(organizationId: string | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/projects/project-availability?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckActiveProjectAvailable(_response));
        });
    }

    protected processCheckActiveProjectAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    checkProjectNameAvailable(model: CreateProjectModel , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/projects/name-availability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckProjectNameAvailable(_response));
        });
    }

    protected processCheckProjectNameAvailable(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    archivedUserProjects(  cancelToken?: CancelToken | undefined): Promise<ProjectSummary[]> {
        let url_ = this.baseUrl + "/api/projects/archived";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchivedUserProjects(_response));
        });
    }

    protected processArchivedUserProjects(response: AxiosResponse): Promise<ProjectSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectSummary[]>(null as any);
    }

    getProjectDetails(projectId: string , cancelToken?: CancelToken | undefined): Promise<ProjectDetailsModel> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetProjectDetails(_response));
        });
    }

    protected processGetProjectDetails(response: AxiosResponse): Promise<ProjectDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDetailsModel.fromJS(resultData200);
            return Promise.resolve<ProjectDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDetailsModel>(null as any);
    }

    updateProjectName(projectId: string, model: RenameProjectModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/rename";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProjectName(_response));
        });
    }

    protected processUpdateProjectName(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    archiveProject(projectId: string , cancelToken?: CancelToken | undefined): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/projects/archive/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processArchiveProject(_response));
        });
    }

    protected processArchiveProject(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }

    unarchiveProject(projectId: string , cancelToken?: CancelToken | undefined): Promise<ServiceOutcome> {
        let url_ = this.baseUrl + "/api/projects/unarchive/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUnarchiveProject(_response));
        });
    }

    protected processUnarchiveProject(response: AxiosResponse): Promise<ServiceOutcome> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceOutcome.fromJS(resultData200);
            return Promise.resolve<ServiceOutcome>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceOutcome>(null as any);
    }

    getAllMembers(organizationId: string | undefined, projectId: string | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationMemberProjectModel[]> {
        let url_ = this.baseUrl + "/api/projects/project-member/all?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllMembers(_response));
        });
    }

    protected processGetAllMembers(response: AxiosResponse): Promise<OrganizationMemberProjectModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationMemberProjectModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationMemberProjectModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationMemberProjectModel[]>(null as any);
    }

    getAllAvailableMembers(organizationId: string | undefined, projectId: string | undefined , cancelToken?: CancelToken | undefined): Promise<OrganizationMemberSummaryModel[]> {
        let url_ = this.baseUrl + "/api/projects/project-member/available?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllAvailableMembers(_response));
        });
    }

    protected processGetAllAvailableMembers(response: AxiosResponse): Promise<OrganizationMemberSummaryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationMemberSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationMemberSummaryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationMemberSummaryModel[]>(null as any);
    }

    addMemberToProject(model: AddProjectMemberModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/project-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddMemberToProject(_response));
        });
    }

    protected processAddMemberToProject(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateMemberToProject(organizationMemberProjectId: string, model: UpdateProjectMemberModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/project-member/{organizationMemberProjectId}";
        if (organizationMemberProjectId === undefined || organizationMemberProjectId === null)
            throw new Error("The parameter 'organizationMemberProjectId' must be defined.");
        url_ = url_.replace("{organizationMemberProjectId}", encodeURIComponent("" + organizationMemberProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateMemberToProject(_response));
        });
    }

    protected processUpdateMemberToProject(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteMemberFromProject(organizationId: string | undefined, organizationMemberProjectId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/projects/project-member/{organizationMemberProjectId}?";
        if (organizationMemberProjectId === undefined || organizationMemberProjectId === null)
            throw new Error("The parameter 'organizationMemberProjectId' must be defined.");
        url_ = url_.replace("{organizationMemberProjectId}", encodeURIComponent("" + organizationMemberProjectId));
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteMemberFromProject(_response));
        });
    }

    protected processDeleteMemberFromProject(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class OrganizationsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getOrganization(organizationId: string , cancelToken?: CancelToken | undefined): Promise<OrganizationModel> {
        let url_ = this.baseUrl + "/api/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrganization(_response));
        });
    }

    protected processGetOrganization(response: AxiosResponse): Promise<OrganizationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationModel.fromJS(resultData200);
            return Promise.resolve<OrganizationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationModel>(null as any);
    }

    inviteMember(model: InviteMemberModel , cancelToken?: CancelToken | undefined): Promise<OrganizationMemberModel> {
        let url_ = this.baseUrl + "/api/organizations/invite-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processInviteMember(_response));
        });
    }

    protected processInviteMember(response: AxiosResponse): Promise<OrganizationMemberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationMemberModel.fromJS(resultData200);
            return Promise.resolve<OrganizationMemberModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationMemberModel>(null as any);
    }

    updateName(model: UpdateNameModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/organizations/update-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateName(_response));
        });
    }

    protected processUpdateName(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    removeMember(model: RemoveMemberModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/organizations/remove-member";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveMember(_response));
        });
    }

    protected processRemoveMember(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setMemberPermissions(model: SetMemberPermissionsModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/organizations/set-permissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetMemberPermissions(_response));
        });
    }

    protected processSetMemberPermissions(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MarketingClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    sendContactEmail(contactModel: ContactModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/marketing/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contactModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendContactEmail(_response));
        });
    }

    protected processSendContactEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentVariablesClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createVariable(documentVersionId: string, model: CreateDocumentVariableModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-variables/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateVariable(_response));
        });
    }

    protected processCreateVariable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getVariables(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentVariableModel[]> {
        let url_ = this.baseUrl + "/api/document-variables/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetVariables(_response));
        });
    }

    protected processGetVariables(response: AxiosResponse): Promise<DocumentVariableModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentVariableModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentVariableModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentVariableModel[]>(null as any);
    }

    updateVariable(documentVariableId: string, model: UpdateDocumentVariableValueModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-variables/{documentVariableId}";
        if (documentVariableId === undefined || documentVariableId === null)
            throw new Error("The parameter 'documentVariableId' must be defined.");
        url_ = url_.replace("{documentVariableId}", encodeURIComponent("" + documentVariableId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateVariable(_response));
        });
    }

    protected processUpdateVariable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentAuditClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getTimelineForDocumentVersion(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentSectionAuditEntry[]> {
        let url_ = this.baseUrl + "/api/audits/documents/versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimelineForDocumentVersion(_response));
        });
    }

    protected processGetTimelineForDocumentVersion(response: AxiosResponse): Promise<DocumentSectionAuditEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentSectionAuditEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentSectionAuditEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentSectionAuditEntry[]>(null as any);
    }

    getTimelineForSection(documentSectionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentSectionAuditEntry[]> {
        let url_ = this.baseUrl + "/api/audits/sections/{documentSectionId}";
        if (documentSectionId === undefined || documentSectionId === null)
            throw new Error("The parameter 'documentSectionId' must be defined.");
        url_ = url_.replace("{documentSectionId}", encodeURIComponent("" + documentSectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTimelineForSection(_response));
        });
    }

    protected processGetTimelineForSection(response: AxiosResponse): Promise<DocumentSectionAuditEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentSectionAuditEntry.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentSectionAuditEntry[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentSectionAuditEntry[]>(null as any);
    }
}

export class DocumentsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    create(model: CreateDocumentModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    projectDocumentSummary(projectId: string , cancelToken?: CancelToken | undefined): Promise<DocumentHeadingModel[]> {
        let url_ = this.baseUrl + "/api/documents/summary/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processProjectDocumentSummary(_response));
        });
    }

    protected processProjectDocumentSummary(response: AxiosResponse): Promise<DocumentHeadingModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentHeadingModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentHeadingModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentHeadingModel[]>(null as any);
    }

    createSection(model: CreateSectionModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/createSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateSection(_response));
        });
    }

    protected processCreateSection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateSection(sectionId: string, model: UpdateSectionModel , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/sections/{sectionId}";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSection(_response));
        });
    }

    protected processUpdateSection(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    deleteSection(sectionId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/sections/{sectionId}";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteSection(_response));
        });
    }

    protected processDeleteSection(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDocumentSections(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<SectionHeading[]> {
        let url_ = this.baseUrl + "/api/documents/getSections/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocumentSections(_response));
        });
    }

    protected processGetDocumentSections(response: AxiosResponse): Promise<SectionHeading[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionHeading.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SectionHeading[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionHeading[]>(null as any);
    }

    renameDocument(documentId: string, model: RenameDocumentModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/rename";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRenameDocument(_response));
        });
    }

    protected processRenameDocument(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createDocumentVersion(documentId: string, isReviewVersion: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/{documentId}/versions?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (isReviewVersion === null)
            throw new Error("The parameter 'isReviewVersion' cannot be null.");
        else if (isReviewVersion !== undefined)
            url_ += "isReviewVersion=" + encodeURIComponent("" + isReviewVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateDocumentVersion(_response));
        });
    }

    protected processCreateDocumentVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    renameDocumentVersion(documentVersionId: string, model: RenameDocumentModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/versions/{documentVersionId}/rename";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRenameDocumentVersion(_response));
        });
    }

    protected processRenameDocumentVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    setDocumentVersionStatus(documentVersionId: string, model: UpdateDocumentVersionStatusModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/versions/{documentVersionId}/update-status";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSetDocumentVersionStatus(_response));
        });
    }

    protected processSetDocumentVersionStatus(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateDocumentVersionFontFamily(documentVersionId: string, model: UpdateDocumentVersionFontFamily , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/versions/{documentVersionId}/update-font";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateDocumentVersionFontFamily(_response));
        });
    }

    protected processUpdateDocumentVersionFontFamily(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    approveDocumentVersion(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/documents/versions/{documentVersionId}/approve";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processApproveDocumentVersion(_response));
        });
    }

    protected processApproveDocumentVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDocumentDetails(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentVersionDetails> {
        let url_ = this.baseUrl + "/api/documents/documents/versions/{documentVersionId}/details";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetDocumentDetails(_response));
        });
    }

    protected processGetDocumentDetails(response: AxiosResponse): Promise<DocumentVersionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentVersionDetails.fromJS(resultData200);
            return Promise.resolve<DocumentVersionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentVersionDetails>(null as any);
    }

    getSectionDetails(sectionId: string , cancelToken?: CancelToken | undefined): Promise<SectionDetails> {
        let url_ = this.baseUrl + "/api/documents/documents/sections/{sectionId}";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSectionDetails(_response));
        });
    }

    protected processGetSectionDetails(response: AxiosResponse): Promise<SectionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionDetails.fromJS(resultData200);
            return Promise.resolve<SectionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionDetails>(null as any);
    }

    getSectionVersionDetails(documentSectionVersionId: string , cancelToken?: CancelToken | undefined): Promise<SectionVersionDetails> {
        let url_ = this.baseUrl + "/api/documents/documents/sections/versions/{documentSectionVersionId}";
        if (documentSectionVersionId === undefined || documentSectionVersionId === null)
            throw new Error("The parameter 'documentSectionVersionId' must be defined.");
        url_ = url_.replace("{documentSectionVersionId}", encodeURIComponent("" + documentSectionVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSectionVersionDetails(_response));
        });
    }

    protected processGetSectionVersionDetails(response: AxiosResponse): Promise<SectionVersionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionVersionDetails.fromJS(resultData200);
            return Promise.resolve<SectionVersionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionVersionDetails>(null as any);
    }

    getSectionVersionOriginalDetails(documentSectionId: string | undefined , cancelToken?: CancelToken | undefined): Promise<SectionVersionDetails> {
        let url_ = this.baseUrl + "/api/documents/documents/sections/versions/original?";
        if (documentSectionId === null)
            throw new Error("The parameter 'documentSectionId' cannot be null.");
        else if (documentSectionId !== undefined)
            url_ += "documentSectionId=" + encodeURIComponent("" + documentSectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetSectionVersionOriginalDetails(_response));
        });
    }

    protected processGetSectionVersionOriginalDetails(response: AxiosResponse): Promise<SectionVersionDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionVersionDetails.fromJS(resultData200);
            return Promise.resolve<SectionVersionDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionVersionDetails>(null as any);
    }

    getOrderOfSections(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<SectionOrderModel[]> {
        let url_ = this.baseUrl + "/api/documents/documents/versions/{documentVersionId}/sections/order";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrderOfSections(_response));
        });
    }

    protected processGetOrderOfSections(response: AxiosResponse): Promise<SectionOrderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionOrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SectionOrderModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionOrderModel[]>(null as any);
    }

    updateSectionOrder(sectionId: string, model: UpdateSectionOrderRequest , cancelToken?: CancelToken | undefined): Promise<SectionOrderModel[]> {
        let url_ = this.baseUrl + "/api/documents/documents/versions/sections/{sectionId}/order";
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateSectionOrder(_response));
        });
    }

    protected processUpdateSectionOrder(response: AxiosResponse): Promise<SectionOrderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionOrderModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SectionOrderModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionOrderModel[]>(null as any);
    }
}

export class ExportClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    exportDocumentVersion(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/export/documents/versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processExportDocumentVersion(_response));
        });
    }

    protected processExportDocumentVersion(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentReferenceClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createReference(documentVersionId: string, model: CreateDocumentReferenceModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-references/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateReference(_response));
        });
    }

    protected processCreateReference(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getReferences(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentReferenceModel[]> {
        let url_ = this.baseUrl + "/api/document-references/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetReferences(_response));
        });
    }

    protected processGetReferences(response: AxiosResponse): Promise<DocumentReferenceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentReferenceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentReferenceModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentReferenceModel[]>(null as any);
    }

    updateVariable(documentReferenceId: string, model: UpdateDocumentReferenceDetailsModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-references/{documentReferenceId}";
        if (documentReferenceId === undefined || documentReferenceId === null)
            throw new Error("The parameter 'documentReferenceId' must be defined.");
        url_ = url_.replace("{documentReferenceId}", encodeURIComponent("" + documentReferenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateVariable(_response));
        });
    }

    protected processUpdateVariable(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DocumentAbbreviationsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    createAbbreviation(documentVersionId: string, model: CreateDocumentAbbreviationModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-abbreviations/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateAbbreviation(_response));
        });
    }

    protected processCreateAbbreviation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getAbbreviations(documentVersionId: string , cancelToken?: CancelToken | undefined): Promise<DocumentAbbreviationModel[]> {
        let url_ = this.baseUrl + "/api/document-abbreviations/document-versions/{documentVersionId}";
        if (documentVersionId === undefined || documentVersionId === null)
            throw new Error("The parameter 'documentVersionId' must be defined.");
        url_ = url_.replace("{documentVersionId}", encodeURIComponent("" + documentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAbbreviations(_response));
        });
    }

    protected processGetAbbreviations(response: AxiosResponse): Promise<DocumentAbbreviationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentAbbreviationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentAbbreviationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentAbbreviationModel[]>(null as any);
    }

    updateAbbreviation(documentAbbreviationId: string, model: UpdateDocumentAbbreviationValueModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/document-abbreviations/{documentAbbreviationId}";
        if (documentAbbreviationId === undefined || documentAbbreviationId === null)
            throw new Error("The parameter 'documentAbbreviationId' must be defined.");
        url_ = url_.replace("{documentAbbreviationId}", encodeURIComponent("" + documentAbbreviationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateAbbreviation(_response));
        });
    }

    protected processUpdateAbbreviation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class DemographicsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getCountries(  cancelToken?: CancelToken | undefined): Promise<CountryModel[]> {
        let url_ = this.baseUrl + "/api/Demographics/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCountries(_response));
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<CountryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CountryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryModel[]>(null as any);
    }

    getStates(countryId: number | undefined , cancelToken?: CancelToken | undefined): Promise<StateModel[]> {
        let url_ = this.baseUrl + "/api/Demographics/states?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStates(_response));
        });
    }

    protected processGetStates(response: AxiosResponse): Promise<StateModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StateModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StateModel[]>(null as any);
    }

    getCities(stateId: number | undefined , cancelToken?: CancelToken | undefined): Promise<CityModel[]> {
        let url_ = this.baseUrl + "/api/Demographics/cities?";
        if (stateId === null)
            throw new Error("The parameter 'stateId' cannot be null.");
        else if (stateId !== undefined)
            url_ += "stateId=" + encodeURIComponent("" + stateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCities(_response));
        });
    }

    protected processGetCities(response: AxiosResponse): Promise<CityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CityModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CityModel[]>(null as any);
    }
}

export class AttachmentsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    get(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGet(_response));
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    delete(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AdminClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getAllUsers(  cancelToken?: CancelToken | undefined): Promise<AdminUserModel[]> {
        let url_ = this.baseUrl + "/api/admin/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllUsers(_response));
        });
    }

    protected processGetAllUsers(response: AxiosResponse): Promise<AdminUserModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdminUserModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminUserModel[]>(null as any);
    }

    getUsersInTemplateCreatorRole(  cancelToken?: CancelToken | undefined): Promise<AdminUserModel[]> {
        let url_ = this.baseUrl + "/api/admin/users/inTemplateCreatorRole";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUsersInTemplateCreatorRole(_response));
        });
    }

    protected processGetUsersInTemplateCreatorRole(response: AxiosResponse): Promise<AdminUserModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminUserModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AdminUserModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AdminUserModel[]>(null as any);
    }

    addUserToTemplateCreatorRole(userId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/users/{userId}/templateCreatorRole";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAddUserToTemplateCreatorRole(_response));
        });
    }

    protected processAddUserToTemplateCreatorRole(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    removeUserFromTemplateCreatorRole(userId: string , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/admin/users/{userId}/templateCreatorRole";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRemoveUserFromTemplateCreatorRole(_response));
        });
    }

    protected processRemoveUserFromTemplateCreatorRole(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AccountsClient extends AxiosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("https://localhost:7122");

    }

    getUserProfile(  cancelToken?: CancelToken | undefined): Promise<ProfileModel> {
        let url_ = this.baseUrl + "/api/users/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetUserProfile(_response));
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<ProfileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileModel.fromJS(resultData200);
            return Promise.resolve<ProfileModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileModel>(null as any);
    }

    updateProfile(model: UpdateProfileModel , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/users/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateProfile(_response));
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return Promise.resolve<IdentityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(null as any);
    }

    viewHelper(  cancelToken?: CancelToken | undefined): Promise<ProfileModel> {
        let url_ = this.baseUrl + "/api/users/helperViewed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processViewHelper(_response));
        });
    }

    protected processViewHelper(response: AxiosResponse): Promise<ProfileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileModel.fromJS(resultData200);
            return Promise.resolve<ProfileModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileModel>(null as any);
    }

    getOrganizationMemberInvitation(organizationMemberId: string , cancelToken?: CancelToken | undefined): Promise<OrganizationMemberRegistrationModel> {
        let url_ = this.baseUrl + "/api/users/invitation/{organizationMemberId}";
        if (organizationMemberId === undefined || organizationMemberId === null)
            throw new Error("The parameter 'organizationMemberId' must be defined.");
        url_ = url_.replace("{organizationMemberId}", encodeURIComponent("" + organizationMemberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrganizationMemberInvitation(_response));
        });
    }

    protected processGetOrganizationMemberInvitation(response: AxiosResponse): Promise<OrganizationMemberRegistrationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationMemberRegistrationModel.fromJS(resultData200);
            return Promise.resolve<OrganizationMemberRegistrationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationMemberRegistrationModel>(null as any);
    }

    acceptInvitation(organizationMemberId: string, model: CreateAccountModel , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/users/invitation/{organizationMemberId}";
        if (organizationMemberId === undefined || organizationMemberId === null)
            throw new Error("The parameter 'organizationMemberId' must be defined.");
        url_ = url_.replace("{organizationMemberId}", encodeURIComponent("" + organizationMemberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAcceptInvitation(_response));
        });
    }

    protected processAcceptInvitation(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return Promise.resolve<IdentityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(null as any);
    }

    login(model: LoginModel , cancelToken?: CancelToken | undefined): Promise<LoginTokenResponse> {
        let url_ = this.baseUrl + "/api/users/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogin(_response));
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginTokenResponse.fromJS(resultData200);
            return Promise.resolve<LoginTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginTokenResponse>(null as any);
    }

    verifyPassword(password: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/users/verify?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processVerifyPassword(_response));
        });
    }

    protected processVerifyPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    refreshToken(model: RefreshTokenModel , cancelToken?: CancelToken | undefined): Promise<LoginTokenResponse> {
        let url_ = this.baseUrl + "/api/users/refreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<LoginTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginTokenResponse.fromJS(resultData200);
            return Promise.resolve<LoginTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginTokenResponse>(null as any);
    }

    logout(model: LogoutModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogout(_response));
        });
    }

    protected processLogout(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    checkToken(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/checkToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCheckToken(_response));
        });
    }

    protected processCheckToken(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    confirmEmail(model: CreateAccountModel, token: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/users/confirmEmail?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfirmEmail(_response));
        });
    }

    protected processConfirmEmail(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return Promise.resolve<IdentityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(null as any);
    }

    changePassword(changePasswordModel: ChangePasswordModel , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/users/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return Promise.resolve<IdentityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(null as any);
    }

    forgotPassword(forgotPasswordModel: ForgotPasswordModel , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processForgotPassword(_response));
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    resetForgotPassword(resetForgotPasswordModel: ResetForgotPasswordModel , cancelToken?: CancelToken | undefined): Promise<IdentityResult> {
        let url_ = this.baseUrl + "/api/users/resetForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetForgotPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetForgotPassword(_response));
        });
    }

    protected processResetForgotPassword(response: AxiosResponse): Promise<IdentityResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IdentityResult.fromJS(resultData200);
            return Promise.resolve<IdentityResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdentityResult>(null as any);
    }

    resendConfirmationEmail(email: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/users/resendConfirmationEmail?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResendConfirmationEmail(_response));
        });
    }

    protected processResendConfirmationEmail(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class CreateCommentModel implements ICreateCommentModel {
    documentSectionId!: string;
    comment!: string;

    constructor(data?: ICreateCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionId = _data["documentSectionId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionId"] = this.documentSectionId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateCommentModel {
    documentSectionId: string;
    comment: string;
}

export class CreateReviewModel implements ICreateReviewModel {
    documentSectionId!: string;
    content!: string;

    constructor(data?: ICreateReviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionId = _data["documentSectionId"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateReviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionId"] = this.documentSectionId;
        data["content"] = this.content;
        return data;
    }
}

export interface ICreateReviewModel {
    documentSectionId: string;
    content: string;
}

export class AcceptReviewWithChangesModel implements IAcceptReviewWithChangesModel {
    content!: string;

    constructor(data?: IAcceptReviewWithChangesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AcceptReviewWithChangesModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptReviewWithChangesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        return data;
    }
}

export interface IAcceptReviewWithChangesModel {
    content: string;
}

export class SearchResultModel implements ISearchResultModel {
    accountId!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    profileImageId?: string | undefined;

    constructor(data?: ISearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.profileImageId = _data["profileImageId"];
        }
    }

    static fromJS(data: any): SearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["profileImageId"] = this.profileImageId;
        return data;
    }
}

export interface ISearchResultModel {
    accountId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    profileImageId?: string | undefined;
}

export class ProfileModel implements IProfileModel {
    accountId!: string;
    firstName!: string;
    lastName!: string;
    email!: string;
    profileImageId?: string | undefined;
    adminOrganizationId?: string | undefined;
    organizations!: ProfileOrganizationModel[];
    organizationsNeedingRenewal!: ProfileOrganizationModel[];
    roles!: Roles[];
    hasViewedInitialHelper!: boolean;

    constructor(data?: IProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organizations = [];
            this.organizationsNeedingRenewal = [];
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.profileImageId = _data["profileImageId"];
            this.adminOrganizationId = _data["adminOrganizationId"];
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(ProfileOrganizationModel.fromJS(item));
            }
            if (Array.isArray(_data["organizationsNeedingRenewal"])) {
                this.organizationsNeedingRenewal = [] as any;
                for (let item of _data["organizationsNeedingRenewal"])
                    this.organizationsNeedingRenewal!.push(ProfileOrganizationModel.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.hasViewedInitialHelper = _data["hasViewedInitialHelper"];
        }
    }

    static fromJS(data: any): ProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["profileImageId"] = this.profileImageId;
        data["adminOrganizationId"] = this.adminOrganizationId;
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        if (Array.isArray(this.organizationsNeedingRenewal)) {
            data["organizationsNeedingRenewal"] = [];
            for (let item of this.organizationsNeedingRenewal)
                data["organizationsNeedingRenewal"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["hasViewedInitialHelper"] = this.hasViewedInitialHelper;
        return data;
    }
}

export interface IProfileModel {
    accountId: string;
    firstName: string;
    lastName: string;
    email: string;
    profileImageId?: string | undefined;
    adminOrganizationId?: string | undefined;
    organizations: ProfileOrganizationModel[];
    organizationsNeedingRenewal: ProfileOrganizationModel[];
    roles: Roles[];
    hasViewedInitialHelper: boolean;
}

export class ProfileOrganizationModel implements IProfileOrganizationModel {
    organizationId!: string;
    organizationName!: string;
    organizationPermissions!: OrganizationPermissionType[];
    projects!: OrganizationProjectModel[];
    organizationCanCreateTemplates!: boolean;

    constructor(data?: IProfileOrganizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organizationPermissions = [];
            this.projects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["organizationPermissions"])) {
                this.organizationPermissions = [] as any;
                for (let item of _data["organizationPermissions"])
                    this.organizationPermissions!.push(item);
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(OrganizationProjectModel.fromJS(item));
            }
            this.organizationCanCreateTemplates = _data["organizationCanCreateTemplates"];
        }
    }

    static fromJS(data: any): ProfileOrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileOrganizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.organizationPermissions)) {
            data["organizationPermissions"] = [];
            for (let item of this.organizationPermissions)
                data["organizationPermissions"].push(item);
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["organizationCanCreateTemplates"] = this.organizationCanCreateTemplates;
        return data;
    }
}

export interface IProfileOrganizationModel {
    organizationId: string;
    organizationName: string;
    organizationPermissions: OrganizationPermissionType[];
    projects: OrganizationProjectModel[];
    organizationCanCreateTemplates: boolean;
}

export enum OrganizationPermissionType {
    CanCreateProject = 1,
    CanCreateTemplate = 2,
}

export class OrganizationProjectModel implements IOrganizationProjectModel {
    projectId!: string;
    role!: ProjectRole;

    constructor(data?: IOrganizationProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): OrganizationProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["role"] = this.role;
        return data;
    }
}

export interface IOrganizationProjectModel {
    projectId: string;
    role: ProjectRole;
}

export enum ProjectRole {
    Writer = 1,
    Reviewer = 2,
    Admin = 3,
}

export enum Roles {
    OtiumAdmin = 1,
    OtiumUser = 2,
    OtiumTemplateCreator = 3,
}

export class CreateTemplateVariableModel implements ICreateTemplateVariableModel {
    name!: string;
    value!: string;

    constructor(data?: ICreateTemplateVariableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateTemplateVariableModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateVariableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateTemplateVariableModel {
    name: string;
    value: string;
}

export class UpdateTemplateVariableValueModel implements IUpdateTemplateVariableValueModel {
    value!: string;
    comment?: string | undefined;

    constructor(data?: IUpdateTemplateVariableValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateTemplateVariableValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateVariableValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateTemplateVariableValueModel {
    value: string;
    comment?: string | undefined;
}

export class TemplateVariableModel implements ITemplateVariableModel {
    id!: string;
    name!: string;
    version!: TemplateVariableVersionModel;

    constructor(data?: ITemplateVariableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new TemplateVariableVersionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"] ? TemplateVariableVersionModel.fromJS(_data["version"]) : new TemplateVariableVersionModel();
        }
    }

    static fromJS(data: any): TemplateVariableModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateVariableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateVariableModel {
    id: string;
    name: string;
    version: TemplateVariableVersionModel;
}

export class TemplateVariableVersionModel implements ITemplateVariableVersionModel {
    id!: string;
    versionNumber!: number;
    value!: string;

    constructor(data?: ITemplateVariableVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TemplateVariableVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateVariableVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface ITemplateVariableVersionModel {
    id: string;
    versionNumber: number;
    value: string;
}

export class TemplateSectionAuditEntry implements ITemplateSectionAuditEntry {
    templateSectionId!: string;
    templateSectionVersionId!: string;
    sectionTitle!: string;
    createdOn!: Date;
    account!: AccountModel;

    constructor(data?: ITemplateSectionAuditEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.account = new AccountModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateSectionId = _data["templateSectionId"];
            this.templateSectionVersionId = _data["templateSectionVersionId"];
            this.sectionTitle = _data["sectionTitle"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.account = _data["account"] ? AccountModel.fromJS(_data["account"]) : new AccountModel();
        }
    }

    static fromJS(data: any): TemplateSectionAuditEntry {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionAuditEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateSectionId"] = this.templateSectionId;
        data["templateSectionVersionId"] = this.templateSectionVersionId;
        data["sectionTitle"] = this.sectionTitle;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateSectionAuditEntry {
    templateSectionId: string;
    templateSectionVersionId: string;
    sectionTitle: string;
    createdOn: Date;
    account: AccountModel;
}

export class AccountModel implements IAccountModel {
    accountId!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): AccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IAccountModel {
    accountId: string;
    firstName: string;
    lastName: string;
}

export class TemplateSummary implements ITemplateSummary {
    id!: string;
    name!: string;
    summary!: string;
    organizationName!: string;
    tags!: TemplateTagModel[];

    constructor(data?: ITemplateSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TemplateTagModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateSummary {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateSummary {
    id: string;
    name: string;
    summary: string;
    organizationName: string;
    tags: TemplateTagModel[];
}

export class TemplateTagModel implements ITemplateTagModel {
    tagId!: string;
    tagName!: string;
    categoryName!: string;

    constructor(data?: ITemplateTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): TemplateTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface ITemplateTagModel {
    tagId: string;
    tagName: string;
    categoryName: string;
}

export class CreateTemplateModel implements ICreateTemplateModel {
    name!: string;
    summary!: string;
    organizationId?: string | undefined;

    constructor(data?: ICreateTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.summary = _data["summary"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): CreateTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["summary"] = this.summary;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface ICreateTemplateModel {
    name: string;
    summary: string;
    organizationId?: string | undefined;
}

export class TemplateVersionEditModel implements ITemplateVersionEditModel {
    id!: string;
    name!: string;
    sections!: TemplateSectionEditModel[];

    constructor(data?: ITemplateVersionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(TemplateSectionEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateVersionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateVersionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateVersionEditModel {
    id: string;
    name: string;
    sections: TemplateSectionEditModel[];
}

export class TemplateSectionEditModel implements ITemplateSectionEditModel {
    sectionId!: string;
    version!: TemplateSectionVersionContent;
    sectionNumber!: number[];
    order!: number;
    parentSectionId?: string | undefined;
    subsections!: TemplateSectionEditModel[];

    constructor(data?: ITemplateSectionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new TemplateSectionVersionContent();
            this.sectionNumber = [];
            this.subsections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.version = _data["version"] ? TemplateSectionVersionContent.fromJS(_data["version"]) : new TemplateSectionVersionContent();
            if (Array.isArray(_data["sectionNumber"])) {
                this.sectionNumber = [] as any;
                for (let item of _data["sectionNumber"])
                    this.sectionNumber!.push(item);
            }
            this.order = _data["order"];
            this.parentSectionId = _data["parentSectionId"];
            if (Array.isArray(_data["subsections"])) {
                this.subsections = [] as any;
                for (let item of _data["subsections"])
                    this.subsections!.push(TemplateSectionEditModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateSectionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        if (Array.isArray(this.sectionNumber)) {
            data["sectionNumber"] = [];
            for (let item of this.sectionNumber)
                data["sectionNumber"].push(item);
        }
        data["order"] = this.order;
        data["parentSectionId"] = this.parentSectionId;
        if (Array.isArray(this.subsections)) {
            data["subsections"] = [];
            for (let item of this.subsections)
                data["subsections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateSectionEditModel {
    sectionId: string;
    version: TemplateSectionVersionContent;
    sectionNumber: number[];
    order: number;
    parentSectionId?: string | undefined;
    subsections: TemplateSectionEditModel[];
}

export class TemplateSectionVersionContent implements ITemplateSectionVersionContent {
    templateSectionVersionId!: string;
    title!: string;
    content!: string;
    versionNumber!: number;

    constructor(data?: ITemplateSectionVersionContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateSectionVersionId = _data["templateSectionVersionId"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): TemplateSectionVersionContent {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionVersionContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateSectionVersionId"] = this.templateSectionVersionId;
        data["title"] = this.title;
        data["content"] = this.content;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface ITemplateSectionVersionContent {
    templateSectionVersionId: string;
    title: string;
    content: string;
    versionNumber: number;
}

export class TemplateSectionVersionDetails implements ITemplateSectionVersionDetails {
    id!: string;
    documentSectionId!: string;
    createdOn!: Date;
    versionNumber!: number;
    title!: string;
    content!: string;
    account!: AccountModel;

    constructor(data?: ITemplateSectionVersionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.account = new AccountModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSectionId = _data["documentSectionId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.versionNumber = _data["versionNumber"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.account = _data["account"] ? AccountModel.fromJS(_data["account"]) : new AccountModel();
        }
    }

    static fromJS(data: any): TemplateSectionVersionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionVersionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSectionId"] = this.documentSectionId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["versionNumber"] = this.versionNumber;
        data["title"] = this.title;
        data["content"] = this.content;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateSectionVersionDetails {
    id: string;
    documentSectionId: string;
    createdOn: Date;
    versionNumber: number;
    title: string;
    content: string;
    account: AccountModel;
}

export class ServiceOutcome implements IServiceOutcome {
    isSuccessful!: boolean;

    constructor(data?: IServiceOutcome) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ServiceOutcome {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOutcome();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IServiceOutcome {
    isSuccessful: boolean;
}

export class TemplateEditModel implements ITemplateEditModel {
    templateId!: string;
    name!: string;
    summary!: string;
    versions!: TemplateVersionHeadingModel[];
    tags!: TagModel[];
    publishedVersionId?: string | undefined;

    constructor(data?: ITemplateEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.versions = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.name = _data["name"];
            this.summary = _data["summary"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(TemplateVersionHeadingModel.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagModel.fromJS(item));
            }
            this.publishedVersionId = _data["publishedVersionId"];
        }
    }

    static fromJS(data: any): TemplateEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["name"] = this.name;
        data["summary"] = this.summary;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["publishedVersionId"] = this.publishedVersionId;
        return data;
    }
}

export interface ITemplateEditModel {
    templateId: string;
    name: string;
    summary: string;
    versions: TemplateVersionHeadingModel[];
    tags: TagModel[];
    publishedVersionId?: string | undefined;
}

export class TemplateVersionHeadingModel implements ITemplateVersionHeadingModel {
    templateId!: string;
    templateVersionId!: string;
    versionNumber!: number;
    versionName!: string;

    constructor(data?: ITemplateVersionHeadingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.templateVersionId = _data["templateVersionId"];
            this.versionNumber = _data["versionNumber"];
            this.versionName = _data["versionName"];
        }
    }

    static fromJS(data: any): TemplateVersionHeadingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateVersionHeadingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["templateVersionId"] = this.templateVersionId;
        data["versionNumber"] = this.versionNumber;
        data["versionName"] = this.versionName;
        return data;
    }
}

export interface ITemplateVersionHeadingModel {
    templateId: string;
    templateVersionId: string;
    versionNumber: number;
    versionName: string;
}

export class TagModel implements ITagModel {
    tagId!: string;
    name!: string;
    tagCategoryId!: string;

    constructor(data?: ITagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.name = _data["name"];
            this.tagCategoryId = _data["tagCategoryId"];
        }
    }

    static fromJS(data: any): TagModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["name"] = this.name;
        data["tagCategoryId"] = this.tagCategoryId;
        return data;
    }
}

export interface ITagModel {
    tagId: string;
    name: string;
    tagCategoryId: string;
}

export class TemplateSectionHeading implements ITemplateSectionHeading {
    templateVersionId!: string;
    templateSectionId!: string;
    order!: number;
    subSectionHeadings!: TemplateSectionHeading[];
    version!: TemplateSectionVersionHeadingModel;

    constructor(data?: ITemplateSectionHeading) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subSectionHeadings = [];
            this.version = new TemplateSectionVersionHeadingModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateVersionId = _data["templateVersionId"];
            this.templateSectionId = _data["templateSectionId"];
            this.order = _data["order"];
            if (Array.isArray(_data["subSectionHeadings"])) {
                this.subSectionHeadings = [] as any;
                for (let item of _data["subSectionHeadings"])
                    this.subSectionHeadings!.push(TemplateSectionHeading.fromJS(item));
            }
            this.version = _data["version"] ? TemplateSectionVersionHeadingModel.fromJS(_data["version"]) : new TemplateSectionVersionHeadingModel();
        }
    }

    static fromJS(data: any): TemplateSectionHeading {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionHeading();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateVersionId"] = this.templateVersionId;
        data["templateSectionId"] = this.templateSectionId;
        data["order"] = this.order;
        if (Array.isArray(this.subSectionHeadings)) {
            data["subSectionHeadings"] = [];
            for (let item of this.subSectionHeadings)
                data["subSectionHeadings"].push(item.toJSON());
        }
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITemplateSectionHeading {
    templateVersionId: string;
    templateSectionId: string;
    order: number;
    subSectionHeadings: TemplateSectionHeading[];
    version: TemplateSectionVersionHeadingModel;
}

export class TemplateSectionVersionHeadingModel implements ITemplateSectionVersionHeadingModel {
    templateSectionId!: string;
    templateSectionVersionId!: string;
    versionNumber!: number;
    title!: string;

    constructor(data?: ITemplateSectionVersionHeadingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateSectionId = _data["templateSectionId"];
            this.templateSectionVersionId = _data["templateSectionVersionId"];
            this.versionNumber = _data["versionNumber"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): TemplateSectionVersionHeadingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionVersionHeadingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateSectionId"] = this.templateSectionId;
        data["templateSectionVersionId"] = this.templateSectionVersionId;
        data["versionNumber"] = this.versionNumber;
        data["title"] = this.title;
        return data;
    }
}

export interface ITemplateSectionVersionHeadingModel {
    templateSectionId: string;
    templateSectionVersionId: string;
    versionNumber: number;
    title: string;
}

export class UpdateTemplateSectionRequest implements IUpdateTemplateSectionRequest {
    content!: string;
    title!: string;

    constructor(data?: IUpdateTemplateSectionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateTemplateSectionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateSectionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateTemplateSectionRequest {
    content: string;
    title: string;
}

export class RenameTemplateModel implements IRenameTemplateModel {
    name!: string;

    constructor(data?: IRenameTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameTemplateModel {
    name: string;
}

export class UpdateTemplateSummaryModel implements IUpdateTemplateSummaryModel {
    summary!: string;

    constructor(data?: IUpdateTemplateSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): UpdateTemplateSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary;
        return data;
    }
}

export interface IUpdateTemplateSummaryModel {
    summary: string;
}

export class UpdateTemplateTagsRequest implements IUpdateTemplateTagsRequest {
    tagIds!: string[];

    constructor(data?: IUpdateTemplateTagsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTemplateTagsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateTagsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateTemplateTagsRequest {
    tagIds: string[];
}

export class TemplateSectionOrderModel implements ITemplateSectionOrderModel {
    templateSectionId!: string;
    order!: number;
    subsections!: TemplateSectionOrderModel[];

    constructor(data?: ITemplateSectionOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subsections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateSectionId = _data["templateSectionId"];
            this.order = _data["order"];
            if (Array.isArray(_data["subsections"])) {
                this.subsections = [] as any;
                for (let item of _data["subsections"])
                    this.subsections!.push(TemplateSectionOrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateSectionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateSectionOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateSectionId"] = this.templateSectionId;
        data["order"] = this.order;
        if (Array.isArray(this.subsections)) {
            data["subsections"] = [];
            for (let item of this.subsections)
                data["subsections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateSectionOrderModel {
    templateSectionId: string;
    order: number;
    subsections: TemplateSectionOrderModel[];
}

export class UpdateTemplateSectionOrderRequest implements IUpdateTemplateSectionOrderRequest {
    order!: number;

    constructor(data?: IUpdateTemplateSectionOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateTemplateSectionOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateSectionOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateTemplateSectionOrderRequest {
    order: number;
}

export class PublishTemplateVersionRequest implements IPublishTemplateVersionRequest {
    templateVersionId?: string | undefined;

    constructor(data?: IPublishTemplateVersionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateVersionId = _data["templateVersionId"];
        }
    }

    static fromJS(data: any): PublishTemplateVersionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PublishTemplateVersionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateVersionId"] = this.templateVersionId;
        return data;
    }
}

export interface IPublishTemplateVersionRequest {
    templateVersionId?: string | undefined;
}

export class CreateTemplateAbbreviationModel implements ICreateTemplateAbbreviationModel {
    name!: string;
    value!: string;

    constructor(data?: ICreateTemplateAbbreviationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateTemplateAbbreviationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateAbbreviationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateTemplateAbbreviationModel {
    name: string;
    value: string;
}

export class UpdateTemplateAbbreviationValueModel implements IUpdateTemplateAbbreviationValueModel {
    value!: string;

    constructor(data?: IUpdateTemplateAbbreviationValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateTemplateAbbreviationValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateAbbreviationValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateTemplateAbbreviationValueModel {
    value: string;
}

export class TemplateAbbreviationModel implements ITemplateAbbreviationModel {
    id!: string;
    version!: TemplateAbbreviationVersionModel;
    name!: string;

    constructor(data?: ITemplateAbbreviationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new TemplateAbbreviationVersionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"] ? TemplateAbbreviationVersionModel.fromJS(_data["version"]) : new TemplateAbbreviationVersionModel();
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TemplateAbbreviationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAbbreviationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface ITemplateAbbreviationModel {
    id: string;
    version: TemplateAbbreviationVersionModel;
    name: string;
}

export class TemplateAbbreviationVersionModel implements ITemplateAbbreviationVersionModel {
    id!: string;
    versionNumber!: number;
    value!: string;

    constructor(data?: ITemplateAbbreviationVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TemplateAbbreviationVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateAbbreviationVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface ITemplateAbbreviationVersionModel {
    id: string;
    versionNumber: number;
    value: string;
}

export class TagCategoryModel implements ITagCategoryModel {
    tagCategoryId!: string;
    name!: string;
    tags!: TagModel[];

    constructor(data?: ITagCategoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagCategoryId = _data["tagCategoryId"];
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagCategoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagCategoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagCategoryId"] = this.tagCategoryId;
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITagCategoryModel {
    tagCategoryId: string;
    name: string;
    tags: TagModel[];
}

export class CreateProjectModel implements ICreateProjectModel {
    organizationId!: string;
    name!: string;

    constructor(data?: ICreateProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateProjectModel {
    organizationId: string;
    name: string;
}

export class ProjectSummary implements IProjectSummary {
    id!: string;
    name!: string;
    createdOn!: Date;
    organizationId!: string;
    organizationName!: string;
    createdBy!: string;
    contributors!: OrganizationMemberProjectModel[];
    documents!: DocumentHeadingModel[];
    tags!: ProjectTagModel[];

    constructor(data?: IProjectSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contributors = [];
            this.documents = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.organizationId = _data["organizationId"];
            this.organizationName = _data["organizationName"];
            this.createdBy = _data["createdBy"];
            if (Array.isArray(_data["contributors"])) {
                this.contributors = [] as any;
                for (let item of _data["contributors"])
                    this.contributors!.push(OrganizationMemberProjectModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentHeadingModel.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(ProjectTagModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["organizationId"] = this.organizationId;
        data["organizationName"] = this.organizationName;
        data["createdBy"] = this.createdBy;
        if (Array.isArray(this.contributors)) {
            data["contributors"] = [];
            for (let item of this.contributors)
                data["contributors"].push(item.toJSON());
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectSummary {
    id: string;
    name: string;
    createdOn: Date;
    organizationId: string;
    organizationName: string;
    createdBy: string;
    contributors: OrganizationMemberProjectModel[];
    documents: DocumentHeadingModel[];
    tags: ProjectTagModel[];
}

export class OrganizationMemberProjectModel implements IOrganizationMemberProjectModel {
    organizationMemberProjectId!: string;
    organizationMemberId!: string;
    fullName!: string;
    email!: string;
    hasAllDocuments!: boolean;
    role!: ProjectRole;
    documents!: string[];

    constructor(data?: IOrganizationMemberProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationMemberProjectId = _data["organizationMemberProjectId"];
            this.organizationMemberId = _data["organizationMemberId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.hasAllDocuments = _data["hasAllDocuments"];
            this.role = _data["role"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationMemberProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationMemberProjectId"] = this.organizationMemberProjectId;
        data["organizationMemberId"] = this.organizationMemberId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["hasAllDocuments"] = this.hasAllDocuments;
        data["role"] = this.role;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item);
        }
        return data;
    }
}

export interface IOrganizationMemberProjectModel {
    organizationMemberProjectId: string;
    organizationMemberId: string;
    fullName: string;
    email: string;
    hasAllDocuments: boolean;
    role: ProjectRole;
    documents: string[];
}

export class DocumentHeadingModel implements IDocumentHeadingModel {
    documentId!: string;
    projectId!: string;
    name!: string;
    status!: DocumentStatus;
    versions!: DocumentVersionHeadingModel[];

    constructor(data?: IDocumentHeadingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.versions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.status = _data["status"];
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(DocumentVersionHeadingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentHeadingModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentHeadingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["status"] = this.status;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentHeadingModel {
    documentId: string;
    projectId: string;
    name: string;
    status: DocumentStatus;
    versions: DocumentVersionHeadingModel[];
}

export enum DocumentStatus {
    Draft = 1,
    Final = 2,
}

export class DocumentVersionHeadingModel implements IDocumentVersionHeadingModel {
    documentVersionId!: string;
    documentId!: string;
    versionNumber!: number;
    versionName!: string;
    status!: DocumentVersionStatus;

    constructor(data?: IDocumentVersionHeadingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentVersionId = _data["documentVersionId"];
            this.documentId = _data["documentId"];
            this.versionNumber = _data["versionNumber"];
            this.versionName = _data["versionName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DocumentVersionHeadingModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionHeadingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentVersionId"] = this.documentVersionId;
        data["documentId"] = this.documentId;
        data["versionNumber"] = this.versionNumber;
        data["versionName"] = this.versionName;
        data["status"] = this.status;
        return data;
    }
}

export interface IDocumentVersionHeadingModel {
    documentVersionId: string;
    documentId: string;
    versionNumber: number;
    versionName: string;
    status: DocumentVersionStatus;
}

export enum DocumentVersionStatus {
    Draft = 1,
    InReview = 2,
    Closed = 3,
    Approved = 4,
}

export class ProjectTagModel implements IProjectTagModel {
    tagId!: string;
    tagName!: string;
    categoryName!: string;

    constructor(data?: IProjectTagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): ProjectTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["categoryName"] = this.categoryName;
        return data;
    }
}

export interface IProjectTagModel {
    tagId: string;
    tagName: string;
    categoryName: string;
}

export class ProjectDetailsModel implements IProjectDetailsModel {
    id!: string;
    name!: string;
    organizationName!: string;
    documents!: DocumentHeadingModel[];

    constructor(data?: IProjectDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.organizationName = _data["organizationName"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentHeadingModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["organizationName"] = this.organizationName;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDetailsModel {
    id: string;
    name: string;
    organizationName: string;
    documents: DocumentHeadingModel[];
}

export class RenameProjectModel implements IRenameProjectModel {
    name!: string;

    constructor(data?: IRenameProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameProjectModel {
    name: string;
}

export class OrganizationMemberSummaryModel implements IOrganizationMemberSummaryModel {
    organizationMemberId!: string;
    fullName!: string;
    email!: string;

    constructor(data?: IOrganizationMemberSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationMemberId = _data["organizationMemberId"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): OrganizationMemberSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationMemberId"] = this.organizationMemberId;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        return data;
    }
}

export interface IOrganizationMemberSummaryModel {
    organizationMemberId: string;
    fullName: string;
    email: string;
}

export class AddProjectMemberModel implements IAddProjectMemberModel {
    organizationId!: string;
    organizationMemberId!: string;
    projectId!: string;
    hasAllDocuments!: boolean;
    role!: ProjectRole;
    documentIds!: string[];

    constructor(data?: IAddProjectMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationMemberId = _data["organizationMemberId"];
            this.projectId = _data["projectId"];
            this.hasAllDocuments = _data["hasAllDocuments"];
            this.role = _data["role"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddProjectMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddProjectMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationMemberId"] = this.organizationMemberId;
        data["projectId"] = this.projectId;
        data["hasAllDocuments"] = this.hasAllDocuments;
        data["role"] = this.role;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IAddProjectMemberModel {
    organizationId: string;
    organizationMemberId: string;
    projectId: string;
    hasAllDocuments: boolean;
    role: ProjectRole;
    documentIds: string[];
}

export class UpdateProjectMemberModel implements IUpdateProjectMemberModel {
    organizationMemberProjectId!: string;
    organizationId!: string;
    hasAllDocuments!: boolean;
    role!: ProjectRole;
    documentIds!: string[];

    constructor(data?: IUpdateProjectMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationMemberProjectId = _data["organizationMemberProjectId"];
            this.organizationId = _data["organizationId"];
            this.hasAllDocuments = _data["hasAllDocuments"];
            this.role = _data["role"];
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateProjectMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationMemberProjectId"] = this.organizationMemberProjectId;
        data["organizationId"] = this.organizationId;
        data["hasAllDocuments"] = this.hasAllDocuments;
        data["role"] = this.role;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }
}

export interface IUpdateProjectMemberModel {
    organizationMemberProjectId: string;
    organizationId: string;
    hasAllDocuments: boolean;
    role: ProjectRole;
    documentIds: string[];
}

export class OrganizationModel implements IOrganizationModel {
    organizationId!: string;
    name!: string;
    members!: OrganizationMemberModel[];

    constructor(data?: IOrganizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.members = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(OrganizationMemberModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationModel {
    organizationId: string;
    name: string;
    members: OrganizationMemberModel[];
}

export class OrganizationMemberModel implements IOrganizationMemberModel {
    memberId!: string;
    accountId?: string | undefined;
    email?: string | undefined;
    fullName!: string;
    memberStatus!: OrganizationMemberStatus;
    invitedOn!: Date;
    acceptedOn?: Date | undefined;
    permissions!: OrganizationPermissionType[];

    constructor(data?: IOrganizationMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"];
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.memberStatus = _data["memberStatus"];
            this.invitedOn = _data["invitedOn"] ? new Date(_data["invitedOn"].toString()) : <any>undefined;
            this.acceptedOn = _data["acceptedOn"] ? new Date(_data["acceptedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["memberStatus"] = this.memberStatus;
        data["invitedOn"] = this.invitedOn ? this.invitedOn.toISOString() : <any>undefined;
        data["acceptedOn"] = this.acceptedOn ? this.acceptedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IOrganizationMemberModel {
    memberId: string;
    accountId?: string | undefined;
    email?: string | undefined;
    fullName: string;
    memberStatus: OrganizationMemberStatus;
    invitedOn: Date;
    acceptedOn?: Date | undefined;
    permissions: OrganizationPermissionType[];
}

export enum OrganizationMemberStatus {
    Pending = 1,
    Accepted = 2,
    Suspended = 3,
}

export class InviteMemberModel implements IInviteMemberModel {
    organizationId!: string;
    email!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IInviteMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): InviteMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new InviteMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IInviteMemberModel {
    organizationId: string;
    email: string;
    firstName: string;
    lastName: string;
}

export class UpdateNameModel implements IUpdateNameModel {
    organizationId!: string;
    name!: string;

    constructor(data?: IUpdateNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdateNameModel {
    organizationId: string;
    name: string;
}

export class RemoveMemberModel implements IRemoveMemberModel {
    organizationId!: string;
    organizationMemberId!: string;

    constructor(data?: IRemoveMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.organizationMemberId = _data["organizationMemberId"];
        }
    }

    static fromJS(data: any): RemoveMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["organizationMemberId"] = this.organizationMemberId;
        return data;
    }
}

export interface IRemoveMemberModel {
    organizationId: string;
    organizationMemberId: string;
}

export class SetMemberPermissionsModel implements ISetMemberPermissionsModel {
    organizationId!: string;
    accountId!: string;
    newPermissions!: OrganizationPermissionType[];

    constructor(data?: ISetMemberPermissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.newPermissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationId = _data["organizationId"];
            this.accountId = _data["accountId"];
            if (Array.isArray(_data["newPermissions"])) {
                this.newPermissions = [] as any;
                for (let item of _data["newPermissions"])
                    this.newPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): SetMemberPermissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetMemberPermissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        data["accountId"] = this.accountId;
        if (Array.isArray(this.newPermissions)) {
            data["newPermissions"] = [];
            for (let item of this.newPermissions)
                data["newPermissions"].push(item);
        }
        return data;
    }
}

export interface ISetMemberPermissionsModel {
    organizationId: string;
    accountId: string;
    newPermissions: OrganizationPermissionType[];
}

export class ContactModel implements IContactModel {
    fullName!: string;
    email!: string;
    contactReason!: ContactReason;
    message!: string;
    recaptchaToken!: string;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.contactReason = _data["contactReason"];
            this.message = _data["message"];
            this.recaptchaToken = _data["recaptchaToken"];
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["contactReason"] = this.contactReason;
        data["message"] = this.message;
        data["recaptchaToken"] = this.recaptchaToken;
        return data;
    }
}

export interface IContactModel {
    fullName: string;
    email: string;
    contactReason: ContactReason;
    message: string;
    recaptchaToken: string;
}

export enum ContactReason {
    BusinessInquiry = 1,
    Investor = 2,
    Press = 3,
}

export class CreateDocumentVariableModel implements ICreateDocumentVariableModel {
    name!: string;
    value!: string;

    constructor(data?: ICreateDocumentVariableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateDocumentVariableModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentVariableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateDocumentVariableModel {
    name: string;
    value: string;
}

export class UpdateDocumentVariableValueModel implements IUpdateDocumentVariableValueModel {
    value!: string;
    comment?: string | undefined;

    constructor(data?: IUpdateDocumentVariableValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateDocumentVariableValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentVariableValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateDocumentVariableValueModel {
    value: string;
    comment?: string | undefined;
}

export class DocumentVariableModel implements IDocumentVariableModel {
    id!: string;
    name!: string;
    version!: DocumentVariableVersionModel;

    constructor(data?: IDocumentVariableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new DocumentVariableVersionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.version = _data["version"] ? DocumentVariableVersionModel.fromJS(_data["version"]) : new DocumentVariableVersionModel();
        }
    }

    static fromJS(data: any): DocumentVariableModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVariableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentVariableModel {
    id: string;
    name: string;
    version: DocumentVariableVersionModel;
}

export class DocumentVariableVersionModel implements IDocumentVariableVersionModel {
    id!: string;
    versionNumber!: number;
    value!: string;

    constructor(data?: IDocumentVariableVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DocumentVariableVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVariableVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface IDocumentVariableVersionModel {
    id: string;
    versionNumber: number;
    value: string;
}

export class DocumentSectionAuditEntry implements IDocumentSectionAuditEntry {
    documentSectionId!: string;
    documentSectionVersionId!: string;
    sectionTitle!: string;
    documentVersionId!: string;
    documentId!: string;
    documentVersionName!: string;
    documentName!: string;
    createdOn!: Date;
    account!: AccountModel;
    comment?: string | undefined;
    reason?: SaveReasonModel | undefined;
    versionNumber!: number;

    constructor(data?: IDocumentSectionAuditEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.account = new AccountModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionId = _data["documentSectionId"];
            this.documentSectionVersionId = _data["documentSectionVersionId"];
            this.sectionTitle = _data["sectionTitle"];
            this.documentVersionId = _data["documentVersionId"];
            this.documentId = _data["documentId"];
            this.documentVersionName = _data["documentVersionName"];
            this.documentName = _data["documentName"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.account = _data["account"] ? AccountModel.fromJS(_data["account"]) : new AccountModel();
            this.comment = _data["comment"];
            this.reason = _data["reason"] ? SaveReasonModel.fromJS(_data["reason"]) : <any>undefined;
            this.versionNumber = _data["versionNumber"];
        }
    }

    static fromJS(data: any): DocumentSectionAuditEntry {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSectionAuditEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionId"] = this.documentSectionId;
        data["documentSectionVersionId"] = this.documentSectionVersionId;
        data["sectionTitle"] = this.sectionTitle;
        data["documentVersionId"] = this.documentVersionId;
        data["documentId"] = this.documentId;
        data["documentVersionName"] = this.documentVersionName;
        data["documentName"] = this.documentName;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["versionNumber"] = this.versionNumber;
        return data;
    }
}

export interface IDocumentSectionAuditEntry {
    documentSectionId: string;
    documentSectionVersionId: string;
    sectionTitle: string;
    documentVersionId: string;
    documentId: string;
    documentVersionName: string;
    documentName: string;
    createdOn: Date;
    account: AccountModel;
    comment?: string | undefined;
    reason?: SaveReasonModel | undefined;
    versionNumber: number;
}

export class SaveReasonModel implements ISaveReasonModel {
    id!: string;
    value!: string;

    constructor(data?: ISaveReasonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SaveReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new SaveReasonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

export interface ISaveReasonModel {
    id: string;
    value: string;
}

export class CreateDocumentModel implements ICreateDocumentModel {
    title!: string;
    projectId!: string;
    templateId!: string;

    constructor(data?: ICreateDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.projectId = _data["projectId"];
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): CreateDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["projectId"] = this.projectId;
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface ICreateDocumentModel {
    title: string;
    projectId: string;
    templateId: string;
}

export class CreateSectionModel implements ICreateSectionModel {
    documentVersionId!: string;
    title!: string;
    order!: number;
    parentSectionId?: string | undefined;

    constructor(data?: ICreateSectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentVersionId = _data["documentVersionId"];
            this.title = _data["title"];
            this.order = _data["order"];
            this.parentSectionId = _data["parentSectionId"];
        }
    }

    static fromJS(data: any): CreateSectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentVersionId"] = this.documentVersionId;
        data["title"] = this.title;
        data["order"] = this.order;
        data["parentSectionId"] = this.parentSectionId;
        return data;
    }
}

export interface ICreateSectionModel {
    documentVersionId: string;
    title: string;
    order: number;
    parentSectionId?: string | undefined;
}

export class UpdateSectionModel implements IUpdateSectionModel {
    title!: string;
    content!: string;
    comment!: string;
    reasonId?: string | undefined;

    constructor(data?: IUpdateSectionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.content = _data["content"];
            this.comment = _data["comment"];
            this.reasonId = _data["reasonId"];
        }
    }

    static fromJS(data: any): UpdateSectionModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["content"] = this.content;
        data["comment"] = this.comment;
        data["reasonId"] = this.reasonId;
        return data;
    }
}

export interface IUpdateSectionModel {
    title: string;
    content: string;
    comment: string;
    reasonId?: string | undefined;
}

export class SectionHeading implements ISectionHeading {
    sectionId!: string;
    documentVersionId!: string;
    openCommentCount!: number;
    order!: number;
    subsections!: SectionHeading[];
    currentVersion!: SectionVersionHeading;

    constructor(data?: ISectionHeading) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subsections = [];
            this.currentVersion = new SectionVersionHeading();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.documentVersionId = _data["documentVersionId"];
            this.openCommentCount = _data["openCommentCount"];
            this.order = _data["order"];
            if (Array.isArray(_data["subsections"])) {
                this.subsections = [] as any;
                for (let item of _data["subsections"])
                    this.subsections!.push(SectionHeading.fromJS(item));
            }
            this.currentVersion = _data["currentVersion"] ? SectionVersionHeading.fromJS(_data["currentVersion"]) : new SectionVersionHeading();
        }
    }

    static fromJS(data: any): SectionHeading {
        data = typeof data === 'object' ? data : {};
        let result = new SectionHeading();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["documentVersionId"] = this.documentVersionId;
        data["openCommentCount"] = this.openCommentCount;
        data["order"] = this.order;
        if (Array.isArray(this.subsections)) {
            data["subsections"] = [];
            for (let item of this.subsections)
                data["subsections"].push(item.toJSON());
        }
        data["currentVersion"] = this.currentVersion ? this.currentVersion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISectionHeading {
    sectionId: string;
    documentVersionId: string;
    openCommentCount: number;
    order: number;
    subsections: SectionHeading[];
    currentVersion: SectionVersionHeading;
}

export class SectionVersionHeading implements ISectionVersionHeading {
    sectionVersionId!: string;
    sectionId!: string;
    title!: string;
    versionNumber!: number;
    createdOn!: Date;

    constructor(data?: ISectionVersionHeading) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionVersionId = _data["sectionVersionId"];
            this.sectionId = _data["sectionId"];
            this.title = _data["title"];
            this.versionNumber = _data["versionNumber"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SectionVersionHeading {
        data = typeof data === 'object' ? data : {};
        let result = new SectionVersionHeading();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionVersionId"] = this.sectionVersionId;
        data["sectionId"] = this.sectionId;
        data["title"] = this.title;
        data["versionNumber"] = this.versionNumber;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISectionVersionHeading {
    sectionVersionId: string;
    sectionId: string;
    title: string;
    versionNumber: number;
    createdOn: Date;
}

export class RenameDocumentModel implements IRenameDocumentModel {
    name!: string;

    constructor(data?: IRenameDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new RenameDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameDocumentModel {
    name: string;
}

export class UpdateDocumentVersionStatusModel implements IUpdateDocumentVersionStatusModel {
    status!: DocumentVersionStatus;

    constructor(data?: IUpdateDocumentVersionStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateDocumentVersionStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentVersionStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateDocumentVersionStatusModel {
    status: DocumentVersionStatus;
}

export class UpdateDocumentVersionFontFamily implements IUpdateDocumentVersionFontFamily {
    fontFamily!: FontFamily;

    constructor(data?: IUpdateDocumentVersionFontFamily) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fontFamily = _data["fontFamily"];
        }
    }

    static fromJS(data: any): UpdateDocumentVersionFontFamily {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentVersionFontFamily();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fontFamily"] = this.fontFamily;
        return data;
    }
}

export interface IUpdateDocumentVersionFontFamily {
    fontFamily: FontFamily;
}

export enum FontFamily {
    Default = "Default",
    Arial = "Arial",
    Verdana = "Verdana",
    Helvetica = "Helvetica",
    Tahoma = "Tahoma",
    Times = "Times",
    Georgia = "Georgia",
    Garamond = "Garamond",
}

export class DocumentVersionDetails implements IDocumentVersionDetails {
    id!: string;
    documentId!: string;
    versionNumber!: number;
    versionName!: string;
    status!: DocumentVersionStatus;
    fontFamily?: FontFamily | undefined;
    saveReasons!: SaveReasonModel[];
    sections!: SectionDetails[];

    constructor(data?: IDocumentVersionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.saveReasons = [];
            this.sections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentId = _data["documentId"];
            this.versionNumber = _data["versionNumber"];
            this.versionName = _data["versionName"];
            this.status = _data["status"];
            this.fontFamily = _data["fontFamily"];
            if (Array.isArray(_data["saveReasons"])) {
                this.saveReasons = [] as any;
                for (let item of _data["saveReasons"])
                    this.saveReasons!.push(SaveReasonModel.fromJS(item));
            }
            if (Array.isArray(_data["sections"])) {
                this.sections = [] as any;
                for (let item of _data["sections"])
                    this.sections!.push(SectionDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentVersionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentVersionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentId"] = this.documentId;
        data["versionNumber"] = this.versionNumber;
        data["versionName"] = this.versionName;
        data["status"] = this.status;
        data["fontFamily"] = this.fontFamily;
        if (Array.isArray(this.saveReasons)) {
            data["saveReasons"] = [];
            for (let item of this.saveReasons)
                data["saveReasons"].push(item.toJSON());
        }
        if (Array.isArray(this.sections)) {
            data["sections"] = [];
            for (let item of this.sections)
                data["sections"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentVersionDetails {
    id: string;
    documentId: string;
    versionNumber: number;
    versionName: string;
    status: DocumentVersionStatus;
    fontFamily?: FontFamily | undefined;
    saveReasons: SaveReasonModel[];
    sections: SectionDetails[];
}

export class SectionDetails implements ISectionDetails {
    id!: string;
    documentVersionId!: string;
    order!: number;
    parentSectionId?: string | undefined;
    openCommentCount!: number;
    sectionNumber!: number[];
    comments!: DocumentSectionCommentModel[];
    sectionReview?: DocumentSectionReviewModel | undefined;
    subsections!: SectionDetails[];
    sectionVersionDetails!: SectionVersionDetails;

    constructor(data?: ISectionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sectionNumber = [];
            this.comments = [];
            this.subsections = [];
            this.sectionVersionDetails = new SectionVersionDetails();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentVersionId = _data["documentVersionId"];
            this.order = _data["order"];
            this.parentSectionId = _data["parentSectionId"];
            this.openCommentCount = _data["openCommentCount"];
            if (Array.isArray(_data["sectionNumber"])) {
                this.sectionNumber = [] as any;
                for (let item of _data["sectionNumber"])
                    this.sectionNumber!.push(item);
            }
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(DocumentSectionCommentModel.fromJS(item));
            }
            this.sectionReview = _data["sectionReview"] ? DocumentSectionReviewModel.fromJS(_data["sectionReview"]) : <any>undefined;
            if (Array.isArray(_data["subsections"])) {
                this.subsections = [] as any;
                for (let item of _data["subsections"])
                    this.subsections!.push(SectionDetails.fromJS(item));
            }
            this.sectionVersionDetails = _data["sectionVersionDetails"] ? SectionVersionDetails.fromJS(_data["sectionVersionDetails"]) : new SectionVersionDetails();
        }
    }

    static fromJS(data: any): SectionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentVersionId"] = this.documentVersionId;
        data["order"] = this.order;
        data["parentSectionId"] = this.parentSectionId;
        data["openCommentCount"] = this.openCommentCount;
        if (Array.isArray(this.sectionNumber)) {
            data["sectionNumber"] = [];
            for (let item of this.sectionNumber)
                data["sectionNumber"].push(item);
        }
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["sectionReview"] = this.sectionReview ? this.sectionReview.toJSON() : <any>undefined;
        if (Array.isArray(this.subsections)) {
            data["subsections"] = [];
            for (let item of this.subsections)
                data["subsections"].push(item.toJSON());
        }
        data["sectionVersionDetails"] = this.sectionVersionDetails ? this.sectionVersionDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISectionDetails {
    id: string;
    documentVersionId: string;
    order: number;
    parentSectionId?: string | undefined;
    openCommentCount: number;
    sectionNumber: number[];
    comments: DocumentSectionCommentModel[];
    sectionReview?: DocumentSectionReviewModel | undefined;
    subsections: SectionDetails[];
    sectionVersionDetails: SectionVersionDetails;
}

export class DocumentSectionCommentModel implements IDocumentSectionCommentModel {
    documentSectionId!: string;
    originatingDocumentVersionName!: string;
    openCommentCount!: number;
    comments!: SectionCommentModel[];

    constructor(data?: IDocumentSectionCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.comments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionId = _data["documentSectionId"];
            this.originatingDocumentVersionName = _data["originatingDocumentVersionName"];
            this.openCommentCount = _data["openCommentCount"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(SectionCommentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentSectionCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSectionCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionId"] = this.documentSectionId;
        data["originatingDocumentVersionName"] = this.originatingDocumentVersionName;
        data["openCommentCount"] = this.openCommentCount;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentSectionCommentModel {
    documentSectionId: string;
    originatingDocumentVersionName: string;
    openCommentCount: number;
    comments: SectionCommentModel[];
}

export class SectionCommentModel implements ISectionCommentModel {
    documentSectionCommentId!: string;
    comment!: string;
    createdOn!: Date;
    originatingSectionId!: string;
    commenterName!: string;
    commenterId!: string;
    status!: CommentStatus;

    constructor(data?: ISectionCommentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionCommentId = _data["documentSectionCommentId"];
            this.comment = _data["comment"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.originatingSectionId = _data["originatingSectionId"];
            this.commenterName = _data["commenterName"];
            this.commenterId = _data["commenterId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SectionCommentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionCommentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionCommentId"] = this.documentSectionCommentId;
        data["comment"] = this.comment;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["originatingSectionId"] = this.originatingSectionId;
        data["commenterName"] = this.commenterName;
        data["commenterId"] = this.commenterId;
        data["status"] = this.status;
        return data;
    }
}

export interface ISectionCommentModel {
    documentSectionCommentId: string;
    comment: string;
    createdOn: Date;
    originatingSectionId: string;
    commenterName: string;
    commenterId: string;
    status: CommentStatus;
}

export enum CommentStatus {
    Open = 1,
    Resolved = 2,
}

export class DocumentSectionReviewModel implements IDocumentSectionReviewModel {
    documentSectionId!: string;
    openReviewCount!: number;
    originatingDocumentVersionName!: string;
    reviews!: SectionReviewModel[];

    constructor(data?: IDocumentSectionReviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reviews = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionId = _data["documentSectionId"];
            this.openReviewCount = _data["openReviewCount"];
            this.originatingDocumentVersionName = _data["originatingDocumentVersionName"];
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(SectionReviewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentSectionReviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSectionReviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionId"] = this.documentSectionId;
        data["openReviewCount"] = this.openReviewCount;
        data["originatingDocumentVersionName"] = this.originatingDocumentVersionName;
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentSectionReviewModel {
    documentSectionId: string;
    openReviewCount: number;
    originatingDocumentVersionName: string;
    reviews: SectionReviewModel[];
}

export class SectionReviewModel implements ISectionReviewModel {
    documentSectionReviewId!: string;
    originatingSectionId!: string;
    content!: string;
    createdOn!: Date;
    reviewerName!: string;
    reviewerId!: string;
    status!: ReviewStatus;

    constructor(data?: ISectionReviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentSectionReviewId = _data["documentSectionReviewId"];
            this.originatingSectionId = _data["originatingSectionId"];
            this.content = _data["content"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.reviewerName = _data["reviewerName"];
            this.reviewerId = _data["reviewerId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SectionReviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionReviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentSectionReviewId"] = this.documentSectionReviewId;
        data["originatingSectionId"] = this.originatingSectionId;
        data["content"] = this.content;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["reviewerName"] = this.reviewerName;
        data["reviewerId"] = this.reviewerId;
        data["status"] = this.status;
        return data;
    }
}

export interface ISectionReviewModel {
    documentSectionReviewId: string;
    originatingSectionId: string;
    content: string;
    createdOn: Date;
    reviewerName: string;
    reviewerId: string;
    status: ReviewStatus;
}

export enum ReviewStatus {
    Open = 1,
    Accepted = 2,
    Rejected = 3,
    AcceptedWithEdits = 4,
}

export class SectionVersionDetails implements ISectionVersionDetails {
    id!: string;
    documentSectionId!: string;
    createdOn!: Date;
    versionNumber!: number;
    title!: string;
    content!: string;
    account!: AccountModel;

    constructor(data?: ISectionVersionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.account = new AccountModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentSectionId = _data["documentSectionId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.versionNumber = _data["versionNumber"];
            this.title = _data["title"];
            this.content = _data["content"];
            this.account = _data["account"] ? AccountModel.fromJS(_data["account"]) : new AccountModel();
        }
    }

    static fromJS(data: any): SectionVersionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new SectionVersionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentSectionId"] = this.documentSectionId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["versionNumber"] = this.versionNumber;
        data["title"] = this.title;
        data["content"] = this.content;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISectionVersionDetails {
    id: string;
    documentSectionId: string;
    createdOn: Date;
    versionNumber: number;
    title: string;
    content: string;
    account: AccountModel;
}

export class SectionOrderModel implements ISectionOrderModel {
    sectionId!: string;
    order!: number;
    subsections!: SectionOrderModel[];

    constructor(data?: ISectionOrderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subsections = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sectionId = _data["sectionId"];
            this.order = _data["order"];
            if (Array.isArray(_data["subsections"])) {
                this.subsections = [] as any;
                for (let item of _data["subsections"])
                    this.subsections!.push(SectionOrderModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionOrderModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionOrderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sectionId"] = this.sectionId;
        data["order"] = this.order;
        if (Array.isArray(this.subsections)) {
            data["subsections"] = [];
            for (let item of this.subsections)
                data["subsections"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISectionOrderModel {
    sectionId: string;
    order: number;
    subsections: SectionOrderModel[];
}

export class UpdateSectionOrderRequest implements IUpdateSectionOrderRequest {
    order!: number;

    constructor(data?: IUpdateSectionOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateSectionOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateSectionOrderRequest {
    order: number;
}

export class CreateDocumentReferenceModel implements ICreateDocumentReferenceModel {
    name!: string;
    details!: string;

    constructor(data?: ICreateDocumentReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): CreateDocumentReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["details"] = this.details;
        return data;
    }
}

export interface ICreateDocumentReferenceModel {
    name: string;
    details: string;
}

export class UpdateDocumentReferenceDetailsModel implements IUpdateDocumentReferenceDetailsModel {
    details!: string;
    comment?: string | undefined;

    constructor(data?: IUpdateDocumentReferenceDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.details = _data["details"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateDocumentReferenceDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentReferenceDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateDocumentReferenceDetailsModel {
    details: string;
    comment?: string | undefined;
}

export class DocumentReferenceModel implements IDocumentReferenceModel {
    id!: string;
    version!: DocumentReferenceVersionModel;
    name!: string;

    constructor(data?: IDocumentReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new DocumentReferenceVersionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"] ? DocumentReferenceVersionModel.fromJS(_data["version"]) : new DocumentReferenceVersionModel();
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentReferenceModel {
    id: string;
    version: DocumentReferenceVersionModel;
    name: string;
}

export class DocumentReferenceVersionModel implements IDocumentReferenceVersionModel {
    id!: string;
    versionNumber!: number;
    details!: string;

    constructor(data?: IDocumentReferenceVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): DocumentReferenceVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentReferenceVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["details"] = this.details;
        return data;
    }
}

export interface IDocumentReferenceVersionModel {
    id: string;
    versionNumber: number;
    details: string;
}

export class CreateDocumentAbbreviationModel implements ICreateDocumentAbbreviationModel {
    name!: string;
    value!: string;

    constructor(data?: ICreateDocumentAbbreviationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateDocumentAbbreviationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentAbbreviationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateDocumentAbbreviationModel {
    name: string;
    value: string;
}

export class UpdateDocumentAbbreviationValueModel implements IUpdateDocumentAbbreviationValueModel {
    value!: string;

    constructor(data?: IUpdateDocumentAbbreviationValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateDocumentAbbreviationValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentAbbreviationValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateDocumentAbbreviationValueModel {
    value: string;
}

export class DocumentAbbreviationModel implements IDocumentAbbreviationModel {
    id!: string;
    version!: DocumentAbbreviationVersionModel;
    name!: string;

    constructor(data?: IDocumentAbbreviationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.version = new DocumentAbbreviationVersionModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.version = _data["version"] ? DocumentAbbreviationVersionModel.fromJS(_data["version"]) : new DocumentAbbreviationVersionModel();
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocumentAbbreviationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAbbreviationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["version"] = this.version ? this.version.toJSON() : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IDocumentAbbreviationModel {
    id: string;
    version: DocumentAbbreviationVersionModel;
    name: string;
}

export class DocumentAbbreviationVersionModel implements IDocumentAbbreviationVersionModel {
    id!: string;
    versionNumber!: number;
    value!: string;

    constructor(data?: IDocumentAbbreviationVersionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DocumentAbbreviationVersionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAbbreviationVersionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["value"] = this.value;
        return data;
    }
}

export interface IDocumentAbbreviationVersionModel {
    id: string;
    versionNumber: number;
    value: string;
}

export class CountryModel implements ICountryModel {
    id!: number;
    name!: string;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICountryModel {
    id: number;
    name: string;
}

export class StateModel implements IStateModel {
    name!: string;
    id!: number;

    constructor(data?: IStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): StateModel {
        data = typeof data === 'object' ? data : {};
        let result = new StateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IStateModel {
    name: string;
    id: number;
}

export class CityModel implements ICityModel {
    name!: string;
    id!: number;

    constructor(data?: ICityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CityModel {
        data = typeof data === 'object' ? data : {};
        let result = new CityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface ICityModel {
    name: string;
    id: number;
}

export class AdminUserModel implements IAdminUserModel {
    userId!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAdminUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AdminUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IAdminUserModel {
    userId: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export class OrganizationMemberRegistrationModel implements IOrganizationMemberRegistrationModel {
    organizationMemberId!: string;
    isRegistered!: boolean;
    email!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IOrganizationMemberRegistrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationMemberId = _data["organizationMemberId"];
            this.isRegistered = _data["isRegistered"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): OrganizationMemberRegistrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationMemberRegistrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationMemberId"] = this.organizationMemberId;
        data["isRegistered"] = this.isRegistered;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IOrganizationMemberRegistrationModel {
    organizationMemberId: string;
    isRegistered: boolean;
    email: string;
    firstName: string;
    lastName: string;
}

export class IdentityResult implements IIdentityResult {
    succeeded!: boolean;
    errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors?: IdentityError[] | undefined;
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class CreateAccountModel implements ICreateAccountModel {
    email!: string;
    password!: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organizationName?: string | undefined;

    constructor(data?: ICreateAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.organizationName = _data["organizationName"];
        }
    }

    static fromJS(data: any): CreateAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["organizationName"] = this.organizationName;
        return data;
    }
}

export interface ICreateAccountModel {
    email: string;
    password: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    organizationName?: string | undefined;
}

export class LoginTokenResponse implements ILoginTokenResponse {
    token!: string;
    expiry!: number;
    refreshToken!: string;

    constructor(data?: ILoginTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.expiry = _data["expiry"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): LoginTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["expiry"] = this.expiry;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILoginTokenResponse {
    token: string;
    expiry: number;
    refreshToken: string;
}

export class LoginModel implements ILoginModel {
    email!: string;
    password!: string;

    constructor(data?: ILoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginModel {
    email: string;
    password: string;
}

export class UpdateProfileModel implements IUpdateProfileModel {
    accountId!: string;
    firstName!: string;
    lastName!: string;
    email!: string;

    constructor(data?: IUpdateProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateProfileModel {
    accountId: string;
    firstName: string;
    lastName: string;
    email: string;
}

export class RefreshTokenModel implements IRefreshTokenModel {
    refreshToken!: string;

    constructor(data?: IRefreshTokenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenModel {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenModel {
    refreshToken: string;
}

export class LogoutModel implements ILogoutModel {
    refreshToken!: string;

    constructor(data?: ILogoutModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): LogoutModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogoutModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface ILogoutModel {
    refreshToken: string;
}

export class ChangePasswordModel implements IChangePasswordModel {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordModel {
    currentPassword: string;
    newPassword: string;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email!: string;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordModel {
    email: string;
}

export class ResetForgotPasswordModel implements IResetForgotPasswordModel {
    token!: string;
    email!: string;
    password!: string;

    constructor(data?: IResetForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IResetForgotPasswordModel {
    token: string;
    email: string;
    password: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}